import { render, staticRenderFns } from "./NewBusinessLogin.vue?vue&type=template&id=9cbbc06c&scoped=true&"
import script from "./NewBusinessLogin.vue?vue&type=script&lang=js&"
export * from "./NewBusinessLogin.vue?vue&type=script&lang=js&"
import style0 from "./NewBusinessLogin.vue?vue&type=style&index=0&id=9cbbc06c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbbc06c",
  null
  
)

export default component.exports